import { render, staticRenderFns } from "./PointingDialog.vue?vue&type=template&id=4ff9d5ee&scoped=true&"
import script from "./PointingDialog.vue?vue&type=script&lang=js&"
export * from "./PointingDialog.vue?vue&type=script&lang=js&"
import style0 from "./PointingDialog.vue?vue&type=style&index=0&id=4ff9d5ee&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4ff9d5ee",
  null
  
)

export default component.exports